import React, {useState, useEffect, useRef} from "react";
import { Link } from "react-router-dom";
import NaverMap from "./NaverMap";
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";

import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import CallWipia from "../Business/CallWipia";



import mainBg from "../../assets/img/bg-contact.jpg";
import icon from "../../assets/img/location-icon.png";
function LocationInfo() {

	// 일반 또는 관리자 header 설정
		const { argInfo } = useContext(ArgContext);
		const isAdmin = argInfo?.role === 'admin';

    const [locationFlag, setLocationFlag]  = useState(true);

	// 영등포 37.5149  126.899
	// 가산   37.4823  126.876
    const fn_locationViewChange = (e) => {
		setLocationFlag(!locationFlag);

    }



    return (
        <>
		<main className="page-wrapper">
			{isAdmin ? <AdminHeader /> : <Header />}
			
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
						<h2>Contact Us</h2>
						<p>위피아에 방문을 요청하시면 전문가들이 상담을 해드립니다.</p>
					</div>
					<SubMenu />
			</section>


			<section className="container-auto location-tab tab-pane fade show active" role="tabpanel">
				<ul className="tabWrap"  role="tablist">
					<li className="tab-item">
						<a className={locationFlag? "active" : ""} onClick={(e)=>{fn_locationViewChange(e)}} href="#" data-bs-toggle="tab" role="tab" >영등포 본사</a>
					</li>
					<li className="tab-item">
						<a className={!locationFlag? "active" : ""} onClick={(e)=>{fn_locationViewChange(e)}} href="#" data-bs-toggle="tab" role="tab">가산지사</a>
					</li>
				</ul>

			
			</section>


				<section className="container-auto location-wrap">
					{/* <!-- 영등포 본사 --> */}
						<div className={locationFlag? "tab-pane fade show active" : "tab-pane fade" } id="map1" role="tabpanel">				
								<h3 className="sub-title">찾아오시는 길</h3>
								<p className="sub-text">서울특별시 영등포구 경인로 775, 1-507(문래동3가, 에이스하이테크시티)</p>
								<div className="mapWrap">
									{locationFlag && <NaverMap let={37.5149} lng={126.899} />}
								</div>

								<ul className="traffic-list">
									<li>
										<p className="title">
											<img src={icon} alt="지하철 이용 시" />
											지하철 이용시
										</p>
										
										<div className="list-box">
											<p><span className="subway2">2호선</span><span className="txt">문래역 6번 출구 (도보 5분)</span></p>
											<p><span className="subway1">1호선</span><span className="txt">영등포역 6번 출구 (도보 8분)</span></p>
										</div>
									</li>
									<li>
										<p className="title">
											<img src={icon} alt="버스 이용 시" />
											버스 이용시
										</p>
										
										<div className="list-box">
											<p className="info">영등포등기소, 구로세무서 정류장에서 하차</p>
											<p><span className="bus1">간선버스</span><span className="txt">503, 670, 260, 160, 600</span></p>
											<p><span className="bus2">지선버스</span><span className="txt">5614, 6512, 6513, 6637, 6640, 5615</span></p>
										</div>
									</li>
								</ul>
						</div>

					{/* <!-- 가산 지사 --> */}
					<div className={!locationFlag? "tab-pane fade show active" : "tab-pane fade" }  id="map2" role="tabpanel">			
								<h3 className="sub-title">찾아오시는 길</h3>
								<p className="sub-text">서울특별시 금천구 가산디지털2로 169-23, 가산모비우스타워 1401-2,3호</p>
								<div className="mapWrap">
									{!locationFlag && <NaverMap let={37.48229292437237} lng={126.87679535188254} /> }
								</div>
								<ul className="traffic-list">
									<li>
										<p className="title">
											<img src={icon} alt="지하철 이용 시" />
											지하철 이용시
										</p>
										
										<div className="list-box">
											<p><span className="subway7">7호선</span><span className="txt">가산디지털단지역 7번, 9번 출구(도보 10분)</span></p>
										</div>
									</li>
									<li>
										<p className="title">
											<img src={icon} alt="버스 이용 시" />
											버스 이용시
										</p>
										
										<div className="list-box">
											<p className="info">디지털3단지운동장 정류장에서 하차</p>
											<p><span className="bus3">일반버스</span><span className="txt">21</span></p>
											<p><span className="bus1">간선버스</span><span className="txt">653</span></p>
											<p><span className="bus2">지선버스</span><span className="txt">5012, 5528</span></p>
										</div>
									</li>
								</ul>
						</div>



				</section>
		</main>
		<CallWipia />
	<Footer />
        </>
    )
}

export default LocationInfo;